import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EntryList from "./components/EntryList";
import EntryDetail from "./components/EntryDetail";
import EntryForm from "./components/EntryForm";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicTable from "./components/PublicTable";
import BookDetail from "./components/BookDetail";
import { AuthProvider } from "./contexts/AuthContext";
import "./global.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Guest + Editor: read-only access to full entry list and detail */}
            <Route
              path="/"
              element={
                <ProtectedRoute minRole="guest">
                  <EntryList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/entry/:id"
              element={
                <ProtectedRoute minRole="guest">
                  <EntryDetail />
                </ProtectedRoute>
              }
            />
            {/* Editor-only: create and edit */}
            <Route
              path="/new"
              element={
                <ProtectedRoute minRole="editor">
                  <EntryForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit/:id"
              element={
                <ProtectedRoute minRole="editor">
                  <EntryForm />
                </ProtectedRoute>
              }
            />
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/public" element={<PublicTable />} />
            <Route path="/detail/:id" element={<BookDetail />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
